export default[
    {
        path: '/contrato/trabalhador/cadastro/:trabalhador_id',
        name: 'cadastro do contrato do trabalhador', 
        component: () => import(/* webpackChunkName: "Login" */ './page/cadastro.vue')
    },
    {
        path: '/contrato/trabalhador/cadastro/:id/:trabalhador_id',
        name: 'cadastro do contrato do trabalhador', 
        component: () => import(/* webpackChunkName: "Login" */ './page/cadastro.vue')
    },
    {
        path: '/contrato/trabalhador/lista/:id',
        name: 'lista de cargo horarias do trabalhador', 
        component: () => import(/* webpackChunkName: "Login" */ './page/lista.vue')
    },
    {
        path: '/contrato/trabalhador/editar/:id/:trabalhador_id',
        name: 'editar contrato do trabalhador', 
        component: () => import(/* webpackChunkName: "Login" */ './page/editar.vue')
    },
]